var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticStyle:{"height":"auto"}},[_c('span',[_vm._v("Informações de contrato")])])}
var staticRenderFns = []

export { render, staticRenderFns }